import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Specials from "../components/Specials";
import Reviews from "../components/Reviews";
import About from "../components/About";
import Tips from "../components/Tips";
import VideoSection from "../components/VideoSection";
import Gallery from "../components/Gallery";
import ServiceAreas from "../components/ServiceAreas";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import CTASection from "../components/CTASection";
import { Toaster } from "../components/ui/toaster";

const Home = () => {
  useEffect(() => {
    document.title = "Smog Check Near Me | Hamilton's Star Smog — Novato & Marin County, CA";
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Services />
        <Specials />
        <About />
        <VideoSection />
        <Gallery />
        <Tips />
        <Reviews />
        <ServiceAreas />
        <FAQ />
        <CTASection />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

export default Home;
